module.exports = __webpack_public_path__ + "img/venueone-fxkfd.574cd192.png";